module.exports = __webpack_public_path__ + "static/media/3.5be776e3.png";